module.exports = {"cart":"Cart","generalAdmission":"GA","reservedSeating":"RS","flexpass":"FL","totalItems":"Total items","totalItem":"Total item","subtotal":"Subtotal","showtixFees":"Fees","callCenterFees":"Call center fees","miscFees":"Misc fees","total":"Total","checkout":"Checkout","cartSummary":"Cart Summary"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/locales/en.json
// module id = 408
// module chunks = 0